import { render, staticRenderFns } from "./editStat.vue?vue&type=template&id=9a2622da"
import script from "./editStat.vue?vue&type=script&lang=js"
export * from "./editStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports